module.exports = __webpack_public_path__ + "static/media/OceanAtlas_logo.f3dce7fd.png";